<template>
  <div class="distribution-performance">
      <div class="title">配送绩效</div>
      <div class="main">
        <late :lateShipment="distributions.lateShipment"></late>
        <PreDeliveryCancellation :preFulfillmentCancellation="distributions.preFulfillmentCancellation" />
        <EffectiveTracking :validTracking="distributions.validTracking" />
        <OnTimeDelivery :onTimeDelivery="distributions.onTimeDelivery" />
      </div>
  </div>
</template>

<script>
import late from "@/views/components/early-warning/late";
import PreDeliveryCancellation from "@/views/components/early-warning/pre-delivery-cancellation";
import EffectiveTracking from "@/views/components/early-warning/effective-tracking";
import OnTimeDelivery from "@/views/components/early-warning/on-time-delivery";

export default {
  props: {
    distributions: {
      default: () => ({})
    }
  },
  components: { late, PreDeliveryCancellation, EffectiveTracking, OnTimeDelivery }
}
</script>

<style scoped lang="scss">
.distribution-performance {
  .title {
    line-height: 50px;
    padding-left: 20px;
    border-bottom: 1px solid #eee;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
}
</style>